import type { Application } from '@domain/entities';
import type { IApplicationRepository } from '@domain/repositories';
import type { PaginatedResult, PaginationParams } from '@application/dto';

export class ListApplicationsUseCase {
  constructor(private readonly applicationRepository: IApplicationRepository) {}

  async execute(params: PaginationParams): Promise<PaginatedResult<Application>> {
    return this.applicationRepository.list(params);
  }
}
